import { ref } from "vue";

const saveSubscriptionButtonRef = ref();
const isStartStream = ref(true);

const sharedRefs = {
  saveSubscriptionButtonRef,
  isStartStream
};

export default sharedRefs;